import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 告警数据实时推送
 */
const messageServer = {

  /**
   * 分配（获取）一个通知实时推送服务器
   */
  allotMessageRealtimeNotifyServer () {
    return axios.post(base.messageServer.allotMessageRealtimeNotifyServer)
  },
}

export default messageServer